import React from "react";
import CitedTableArtifactView from "../components/CitedTableArtifactView";
import { parseCitedTableArtifact } from "../types/citationArtifact";
import { isCitationArtifactsEnabled } from "../utils/featureFlags";
import summaryFixture from "../types/__fixtures__/operating_expense_summary.json";
import partialFixture from "../types/__fixtures__/operating_expense_partial.json";

/**
 * Dev-only preview of the clean citation artifact renderer.
 *
 * Lets us holistically review `CitedTableArtifactView` against the canonical
 * backend fixtures before the backend emits a `cited_table_artifact` content
 * block. Not linked in navigation; reachable at `/dev/citations`.
 */
const DevCitationPreview: React.FC = () => {
	const enabled = isCitationArtifactsEnabled();
	const summary = parseCitedTableArtifact(summaryFixture);
	const partial = parseCitedTableArtifact(partialFixture);

	return (
		<div className="mx-auto max-w-3xl p-6">
			<h1 className="text-xl font-semibold text-text-base">
				Citation Artifact Preview
			</h1>
			<p className="mt-1 text-sm text-text-muted">
				Renders the typed <code>CitedTableArtifact</code> contract directly from
				backend fixtures — no model-authored markdown.
			</p>
			<p className="mt-1 text-xs text-text-muted">
				Flag <code>REACT_APP_CITATION_ARTIFACTS_ENABLED</code> is{" "}
				<span className={enabled ? "text-emerald-600" : "text-red-600"}>
					{enabled ? "ON" : "OFF"}
				</span>{" "}
				(the chat render path is gated on it; this preview always renders).
			</p>

			<section className="mt-6">
				<h2 className="text-lg font-semibold text-text-base">
					Fully verified
				</h2>
				<CitedTableArtifactView artifact={summary} />
			</section>

			<section className="mt-8">
				<h2 className="text-lg font-semibold text-text-base">
					Partial coverage (missing + unverified)
				</h2>
				<CitedTableArtifactView artifact={partial} />
			</section>
		</div>
	);
};

export default DevCitationPreview;
